import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEditNameIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("foreignObject", {
			x: -4,
			y: -4,
			width: 40,
			height: 40,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					clipPath: "url(#bgblur_0_14969_159811_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			"data-figma-bg-blur-radius": 4,
			width: 32,
			height: 32,
			rx: 10,
			fill: "#F0EEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 6H13C8 6 6 8 6 13V19C6 24 8 26 13 26",
			stroke: "#6A4BC0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26 14V17",
			stroke: "#6A4BC0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26 14H22C19 14 18 13 18 10V6L26 14Z",
			stroke: "#6A4BC0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.9784 18.5658L17.1228 22.5005C16.9393 22.6501 16.7308 22.9714 16.6593 23.2066L16.1747 24.9052C16.0015 25.5189 16.3407 26.0184 16.9309 26.0115L18.5686 25.9948C18.7978 25.9908 19.1389 25.8688 19.3234 25.7139L24.179 21.7792C25.0185 21.1003 25.4934 20.242 24.5995 18.9356C23.7088 17.6407 22.8179 17.8869 21.9784 18.5658Z",
			stroke: "#6A4BC0",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1406 19.6582C21.2105 20.7585 21.5742 21.6406 23.1997 22.0349",
			stroke: "#6A4BC0",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 14H14",
			stroke: "#6A4BC0",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 18H18",
			stroke: "#6A4BC0",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "bgblur_0_14969_159811_clip_path",
			transform: "translate(4 4)",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 32,
				height: 32,
				rx: 10
			})
		}) })
	]
});
export default SvgEditNameIcon;
